import { handleActions } from 'redux-actions';
import * as Actions from '../../actions';

const initialState = {
	data: {},
	roles: null,
	overrides: null,
	policies: null,
	createUserOverride: false,
	deleteUserOverride: false,
	updatedUser: false,
	changedPassword: false,
	deletedUser: false,
	createUserRole: false,
	removeUserRole: false
};

const userReducer = handleActions(
	{
		[Actions.fetchUserSuccess]: (state, action) => {
			return {
				...state,
				data: action.payload
			};
		},
		[Actions.fetchUserRolesSuccess]: (state, action) => {
			return {
				...state,
				roles: action.payload
			};
		},
		[Actions.updateUserSuccess]: (state, action) => {
			return {
				...state,
				updatedUser: true,
				data: action.payload
			};
		},
		[Actions.createUserSuccess]: (state, action) => {
			return {
				...state,
				data: action.payload
			};
		},
		[Actions.changeUserPasswordSuccess]: (state, action) => {
			return {
				...state,
				changedPassword: action.payload,
				data: {}
			};
		},
		[Actions.createUserRoleSuccess]: (state, action) => {
			return {
				...state,
				createUserRole: action.payload
			};
		},
		[Actions.removeUserRoleSuccess]: (state, action) => {
			return {
				...state,
				removeUserRole: action.payload
			};
		},
		[Actions.deleteUserSuccess]: (state, action) => {
			return {
				...state,
				deletedUser: action.payload,
				data: {}
			};
		},
		[Actions.fetchUserOverridesSuccess]: (state, action) => {
			return {
				...state,
				overrides: action.payload
			};
		},
		[Actions.createUserOverrideSuccess]: (state, action) => {
			return {
				...state,
				createUserOverride: action.payload
			};
		},
		[Actions.deleteUserOverrideSuccess]: (state, action) => {
			return {
				...state,
				deleteUserOverride: action.payload
			};
		},
		[Actions.fetchUserPoliciesSuccess]: (state, action) => {
			return {
				...state,
				policies: action.payload
			};
		}
	},
	initialState
);

export default userReducer;
